<div class="toaster" [ngClass]="options.toastClass">
	<div
		*ngIf="showIcon"
		class="toast-icon"
		[ngClass]="getDynamicClasses(type, options.toastClass)"
	>
		<ng-container *ngIf="toastType === 'toast-success'">
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
					/>
				</svg>
			</span>
		</ng-container>
		<ng-container *ngIf="toastType === 'toast-info'">
			@if (type === 'toast-inv-report-prepared') {
				<span>
					<svg
						class="size-8"
						viewBox="0 0 200 200"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M116.5 148L84.5 128.5C79.1667 125.333 69.3 115.8 72.5 103C75.7 90.1999 81.8333 71.9999 84.5 64.4999C82.8333 63.8333 78.5 63.1999 74.5 65.9999C70.5 68.7999 63.1667 76.5 60 80C56.8333 82.1667 48.8 84.9 42 78.5C33.5 70.5 43.5 58.5 53.5 50.5C63.5 42.5 73 39.5 84.5 39.5C96 39.5 113.5 45 128 53C142.5 61 147 81 150 83.5C153 86 154.5 88 158 88H169C172.333 88 179.1 90.2 179.5 99C180 110 172 112 170 112H155.5C150.833 111.667 139.4 108.8 131 100C124.203 92.8791 122.84 88.3337 123.098 86.1519L112.5 116.5L129.5 127C134.167 129.667 143.2 137.1 142 145.5C140.8 153.9 134.167 177.333 131 188C129.5 191.333 124.5 197.9 116.5 197.5C106.5 197 104 187 106 180C107.6 174.4 113.667 156.333 116.5 148Z"
							fill="white"
						/>
						<ellipse
							cx="124.951"
							cy="21.882"
							rx="18.951"
							ry="18.882"
							fill="white"
						/>
						<path
							d="M55.5 136.5L63.5 119.5C65 122.333 67.5625 127.5 71.5 132C74.3 135.2 80 138.333 82.5 139.5C82.1667 141 82.1562 144.5 77 152C72.6 158.4 66.5 160 64.5 160H31.5C28 159.667 21 156.8 21 148C21 139.2 28 136.667 31.5 136.5H55.5Z"
							fill="white"
						/>
					</svg>
				</span>
			} @else {
				<span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke-width="1.5"
						stroke="currentColor"
						class="size-8"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
						/>
					</svg>
				</span>
			}
		</ng-container>
		<ng-container *ngIf="toastType === 'toast-error'">
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
					/>
				</svg>
			</span>
		</ng-container>
		<ng-container *ngIf="toastType === 'toast-warning'">
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
					/>
				</svg>
			</span>
		</ng-container>
		<!-- <ng-container *ngIf="type === 'toast-inv-report-email'">
			<span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke-width="1.5"
					stroke="currentColor"
					class="w-6 h-6"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
					/>
				</svg>
			</span>
		</ng-container> -->
	</div>
	<div
		class="toast-details pr-10"
		[ngClass]="{ '!w-[435px] !pr-1': type === 'toast-location-service' }"
	>
		@if (type === 'toast-upgrade') {
			<div class="">
				<div
					*ngIf="title && options.enableHtml"
					role="alert"
					aria-live="polite"
					class="custom-title mt-2 mb-3"
					[innerHTML]="title"
				></div>
				<div class="custom-message mb-4" [class]="options.messageClass">
					<p>
						<span
							class="text-white bg-green-700 hover:bg-green-800 focus:outline-none focus:ring-4 focus:ring-green-300 font-medium rounded-full text-sm px-3 py-2 text-center me-2 mb-2 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800"
							(click)="yesUpgrade()"
							(keydown.enter)="yesUpgrade()"
							(keydown.space)="yesUpgrade()"
							>Yes</span
						>
						<span
							class="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-3 py-2 text-center me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
							(click)="noUpgrade()"
							(keydown.enter)="noUpgrade()"
							(keydown.space)="noUpgrade()"
							>No</span
						>
						<span
							class="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-3 py-2 text-center me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
							style="background-color: #35717c !important"
							(click)="askAgainLaterUpgrade()"
							(keydown.enter)="askAgainLaterUpgrade()"
							(keydown.space)="askAgainLaterUpgrade()"
							>Ask again later</span
						>
					</p>
				</div>
			</div>
		} @else if (type === 'toast-upgrade-recently') {
			<div>
				<div
					*ngIf="title && options.enableHtml"
					role="alert"
					aria-live="polite"
					class="custom-title mt-2 mb-3"
					[innerHTML]="title"
				></div>
				<div class="custom-message mb-4" [class]="options.messageClass">
					<p>
						<span
							class="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-3 py-2 text-center me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
							style="background-color: #35717c !important"
							(click)="checkWhatsNew()"
							(keydown.enter)="checkWhatsNew()"
							(keydown.space)="checkWhatsNew()"
							>Check out what's New!</span
						>
					</p>
				</div>
			</div>
		} @else if (type === 'toast-review-update') {
			<div>
				<div
					*ngIf="title && options.enableHtml"
					role="alert"
					aria-live="polite"
					class="custom-title mt-2 mb-3"
					[innerHTML]="title"
				></div>

				<div class="custom-message mb-4" [class]="options.messageClass">
					<p>
						<span
							class="text-white bg-red-700 hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-full text-sm px-3 py-2 text-center me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
							style="background-color: #35717c !important"
							(click)="ReviewPageReload()"
							(keydown.enter)="ReviewPageReload()"
							(keydown.space)="ReviewPageReload()"
							>Reload</span
						>
					</p>
				</div>
			</div>
		} @else if (type === 'toast-location-service') {
			<div>
				<div class="location-service-message p-2 text-white rounded-lg">
					<h4 class="text-base font-medium leading-relaxed">
						Please update your browser's location permissions to
						provide that prior to attempting to punch in/out.
						<br />
						Most internet browsers provide easy access to this
						setting via
						<span class="inline-flex items-center">
							<span class="mr-1">a pin icon</span>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
								class="w-5 h-5 text-white"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
								/>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
								/>
							</svg>
							<span class="ml-1">in the address bar.</span>
						</span>
					</h4>
				</div>
			</div>
		} @else if (type === 'toast-inv-report-email') {
			<div>
				<!-- text-black  -->
				<div class="location-service-message p-2 rounded-lg">
					<h4 class="text-base font-medium leading-relaxed">
						Your report has finished Generating Successfully.
						<br />
						Please check your Email Inbox
					</h4>
				</div>
			</div>
		} @else if (type === 'toast-inv-report-prepared') {
			<div>
				<!-- text-black  -->
				<div class="location-service-message p-2 rounded-lg">
					<h4 class="text-base font-medium leading-relaxed">
						Your report is being prepared...
						<br />
						Thank you for your patience
					</h4>
				</div>
			</div>
		} @else {
			<div>
				<div
					*ngIf="title"
					[class]="options.titleClass"
					[attr.aria-label]="title"
					class="custom-title"
				>
					{{ title }}
				</div>
				<div
					*ngIf="message && options.enableHtml"
					role="alert"
					aria-live="polite"
					class="custom-message"
					[class]="options.messageClass"
					[innerHTML]="message"
				></div>
				<div
					*ngIf="message && !options.enableHtml"
					role="alert"
					aria-live="polite"
					class="custom-message"
					[class]="options.messageClass"
					[attr.aria-label]="message"
				>
					{{ message }}
				</div>
			</div>
		}
	</div>
	<div class="close-icon !absolute right-[14px] top-[50%] -mt-[16px]">
		<a *ngIf="options.closeButton" (click)="remove()">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
				stroke-width="1.5"
				stroke="currentColor"
				class="w-8"
			>
				<path
					stroke-linecap="round"
					stroke-linejoin="round"
					d="M6 18 18 6M6 6l12 12"
				/>
			</svg>
		</a>
	</div>
</div>
<div *ngIf="options.progressBar">
	<div class="toast-progress" [style.width]="width + '%'"></div>
</div>
